// Estilos de botón del flujo de pago (#1680). `theme.js` pone `&:hover {backgroundColor:
// color-primary}` a TODO MuiButton: un botón ghost (outlined / texto) quedaba con fondo
// teal y texto oscuro en light al pasar el mouse. Acá el hover se declara explícito.
export const botonPrimarioSx = {
  textTransform: "none",
  fontWeight: 700,
  borderRadius: "999px",
  backgroundColor: "var(--color-primary)",
  color: "var(--text-on-primary)",
  "&:hover": { backgroundColor: "var(--color-primary-soft)" },
  "&.Mui-disabled": {
    opacity: 0.45,
    color: "var(--text-on-primary)",
    backgroundColor: "var(--color-primary)",
  },
};

export const botonGhostSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "999px",
  color: "var(--text-primary)",
  borderColor: "var(--border-strong)",
  "&:hover": { backgroundColor: "rgba(var(--fg-rgb), 0.06)", borderColor: "var(--border-strong)" },
};

export const botonTextoSx = {
  textTransform: "none",
  fontWeight: 700,
  color: "var(--color-info)",
  "&:hover": { backgroundColor: "rgba(var(--color-info-rgb), 0.12)" },
};
